import { render, staticRenderFns } from "./RegViewProspectiveStudentFees.vue?vue&type=template&id=e1d3c248"
import script from "./RegViewProspectiveStudentFees.vue?vue&type=script&lang=js"
export * from "./RegViewProspectiveStudentFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports